<template>
  <v-dialog v-model="dialogLembreteSenha" full-width max-width="600px">
    <div class="link" slot="activator">
       Não consegue acessar sua conta?
     </div>
    <v-card>
      <v-card-title>
        <span class="headline">Esqueci minha senha</span>
      </v-card-title>
      <v-form v-model="formValido" ref="form" name="form-login" value="true">
        <v-card-text>
          Preencha o campo abaixo com seu e-mail
          <v-text-field
            name="Email"
            label="E-mail"
            v-model="email"
            :rules="emailRegras"
            prepend-icon="mail_outline"
            required
          ></v-text-field>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" flat="flat" @click.native="dialogLembreteSenha = false">Cancelar</v-btn>
        <v-btn
          :loading="loading"
          @click.native="loader = 'loading'"
          :disabled="loading"
          v-on:click='enviarSenha'
          class="blue--text darken-1"
        >
          Enviar
          <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'lembrete-senha',
  data () {
    return {
      dialogLembreteSenha: false,
      loading: false,
      email: '',
      formValido: false,
      emailRegras: [
        (v) => !!v || 'E-mail em branco',
        (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'E-mail inválido'
      ]
    }
  },
  methods: {

    enviarSenha: function () {
      this.$refs.form.validate()
      if (!this.formValido) {
        return
      }
      this.loading = true
      // http://www.condoplaza.com.br/bin/cotacao/envialogin.asp
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// LembreteSenha.vue?4897e864